module.exports = __webpack_public_path__ + "img/Trillionaire-2.23a13011.png";